import type { ModelOption, ThinkingLevel } from "./types.js";

type ThinkingModel = Pick<ModelOption, "parameters">;

// Keep legacy/custom models unchanged unless their catalog explicitly disables a level.
export function supportsThinkingLevel(model: ThinkingModel | undefined, level: ThinkingLevel): boolean {
  const mapping = model?.parameters.thinkingLevelMap;
  return !mapping || typeof mapping !== "object" || Array.isArray(mapping)
    || (mapping as Record<string, unknown>)[level] !== null;
}

export function compatibleThinkingLevel(model: ThinkingModel | undefined, level: ThinkingLevel): ThinkingLevel {
  if (supportsThinkingLevel(model, level)) return level;
  const fallback = (["low", "medium", "high", "xhigh", "max", "minimal", "off"] as const)
    .find((candidate) => supportsThinkingLevel(model, candidate));
  if (!fallback) throw new Error("模型没有可用的推理档位");
  return fallback;
}
